export enum PushEventTypesEnum {
  JOB_UPDATED = 'job_updated',
  LMS_COURSE_COMPLETED = 'lms_course_completed',
  AI_TAGGING_SAMPLE_APPROVED = 'ai_tagging_sample_approved',
}

export const directPrecogsUpdatedEventName = 'direct_conversation_precog_updated';
export const directPrecogsDeletedEventName = 'direct_conversation_precog_deleted';

export function getConversationRoomName(conversationId: number): string {
  return `conversation-${conversationId}`;
}

export function isPartialTeammateUpdateEvent(eventName: string, data: any) {
  // Partial teammate updates don't have their `class` field set
  return eventName === 'teammate_updated' && !data.class;
}

const legacyPushEventNames = new Set([
  'account_failed',
  'account_saved',
  'analytics_metrics_created',
  'app_notification_received',
  'canned_answer_deleted',
  'canned_answer_updated',
  'canned_answers_updated_batch',
  'canned_answer_folder_created',
  'canned_answer_folder_updated',
  'canned_answer_folder_deleted',
  'canned_answer_folders_updated_batch',
  'card_deleted',
  'card_group_deleted',
  'card_group_updated',
  'card_updated',
  'channel_credentials_failed',
  'channel_credentials_saved',
  'channel_deleted',
  'channel_updated',
  'check_smtp_dns_result',
  'check_smtp_result_completed',
  'check_smtp_result_completed',
  'company_plan_changed',
  'company_status_changed',
  'company_updated',
  'contact_updated',
  'custom_field_deleted',
  'custom_field_updated',
  'export_updated',
  'global_alert',
  'inbox_deleted',
  'inbox_updated',
  'integration_deleted',
  'integration_teammate_settings_updated',
  'integration_test_completed',
  'integration_updated',
  'job_updated',
  'notif_settings_updated',
  'notification_rules_updated',
  'notification_updated',
  'office365_import_saved',
  'plugin_deleted',
  'plugin_updated',
  'role_deleted',
  'role_updated',
  'rule_deleted',
  'rule_updated',
  'sequence_recipient_updated',
  'signature_deleted',
  'signature_updated',
  'tag_id_deleted',
  'tag_updated',
  'team_deleted',
  'team_updated',
  'teammate_changed_update',
  'teammate_deleted',
  'teammate_inboxes_updated',
  'teammate_invited_update_inboxes',
  'teammate_updated',
  'test_pusher',
  'vacation_responder_deleted',
  'vacation_responder_updated',
  'validate_dns_result',
  'validate_smtp_address_result',
]);

export function shouldRelayPushEventToLegacyFrame(eventName: string, data: any) {
  // Partial updates shouldn't be passed to the Angular app because it doesn't handle them properly
  // See https://github.com/frontapp/front-client/pull/3542#discussion_r377719187
  return legacyPushEventNames.has(eventName) && !isPartialTeammateUpdateEvent(eventName, data);
}
